import { render, staticRenderFns } from "./RegisterCustomerCode.vue?vue&type=template&id=06809c9c&scoped=true"
import script from "./RegisterCustomerCode.vue?vue&type=script&lang=js"
export * from "./RegisterCustomerCode.vue?vue&type=script&lang=js"
import style0 from "./RegisterCustomerCode.vue?vue&type=style&index=0&id=06809c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06809c9c",
  null
  
)

export default component.exports